import './scss/index.scss'
import {TooltipComponent} from './TooltipComponent'

const TooltipPackage = {
    name: 'UITooltip',
    configure: function(config) {
        config.addComponent('UITooltip', TooltipComponent, false, 'tooltip')
    }
}

export {TooltipPackage}
